import userSession from '../../../../../../topics/Profile/modules/user-session'
import moment from 'moment'
import options from '../../../../../../config/options.json'

const checkUserExpiration = (days = options.AutomaticLogin.updateBackendUserAfterDays) =>
  userSession.getData() && moment(userSession.getData().lastUpdate).isBefore(moment().subtract(days, 'days'))

export default checkUserExpiration
